// Formatadores compartilhados entre telas.
export const duration = (value?: number) => {
  if (value == null) return "—";
  // Relatórios de um dia podem ter totais abaixo de 1 h: mostrar minutos evita "0d 0h".
  const total = Math.max(0, Math.round(value));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m`;
  return `${total}s`;
};

export const bytes = (value?: number) =>
  value == null
    ? "—"
    : value < 1024
      ? `${value} B`
      : value < 1024 ** 2
        ? `${(value / 1024).toFixed(1)} KB`
        : value < 1024 ** 3
          ? `${(value / 1024 ** 2).toFixed(1)} MB`
          : `${(value / 1024 ** 3).toFixed(1)} GB`;

export const percent = (value?: number) =>
  value == null ? "—" : `${value.toFixed(1)}%`;

export const lifecycleLabel = (state: "ready" | "paused" | "revoked") =>
  ({ ready: "Ativo", paused: "Pausado", revoked: "Revogado" })[state];

export const reasonLabel = (reason?: string) =>
  ({
    periodic: "Periódica",
    visual_change: "Mudança visual",
    mouse_click: "Clique",
    enter_key: "Enter",
    window_changed: "Troca de janela",
  })[reason ?? ""] ?? "Captura";

export const localInput = (date: Date) => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
